<template>
  <v-menu
    v-model="menu"
    bottom
    origin="center center"
    transition="scale-transition"
    :close-on-content-click="false"
    offset-y
    min-width="360"
    max-width="360"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="secondary"
        rounded
        small
        dark
        v-bind="attrs"
        v-on="on"
        outlined
        class="font-weight-bold"
        :block="isMobile()"
      >
        <v-icon>mdi-filter-outline</v-icon> Filtro
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="subtitle-1 font-weight-bold">
        Filtrar cargas
        <v-spacer></v-spacer>
        <v-btn
          rounded
          color="success"
          @click="filtrar()"
          class="font-weight-bold"
          outlined
          small
          >Aplicar filtros</v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Data inicial Carreg."
              v-model="filtros.dtini"
              type="date"
            ></v-text-field>
          </v-col>
          <v-col xl="6" lg="6" md="6" cols="12">
            <v-text-field
              label="Data final Carreg."
              v-model="filtros.dtfim"
              type="date"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-select
              label="Status"
              :items="getStatusCarregar()"
              item-text="descricao"
              no-data-text="Nenhum status localizado"
              multiple
              small-chips
              deletable-chips
              v-model="filtros.status"
              clearable
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("formacaoCarga", ["filtros", "configuracoes"]),
  },
  data: () => ({
    menu: false,
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setIdCarga"]),
    ...mapActions("formacaoCarga", ["buscarCargas"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async filtrar() {
      this.menu = false;
      this.setIdCarga(0);
      await this.buscarCargas();
    },
    getStatusCarregar() {
      return this.configuracoes.dados.status.filter((s) => s.descricao != "");
    },
  },
};
</script>

<style>
</style>